<template>
  <div v-if="Object.keys(data).length"
       class="content--sinoreg Resumo">
    <div>
      <div v-if="data.registro.cod_motivo_alt == 30"
           class="col p-2 Resumo--bg-danger">
        <b>Registro bloqueado por Determinação Judicial</b>
      </div>
    </div>
    <header-blue>
      <h4 class="resumo-show_title pl-2">
        <b-row>
          <div class="pr-0 d-flex align-items-center registro_title pl-3 mt-3">
            <icon-svg icon="nascimento"
                      class="icon--md typeIcon" />
            Nascimento
          </div>
          <div class="registro_dados">
            <b-row>
              <b-col cols="9">
                <b-row class="justify-content-between">
                  <span class="pt-4 resumo-show_title-label">
                    {{ data.registro && data.registro.pessoa && data.registro.pessoa.nome }}
                  </span>
                </b-row>
                <b-row>
                  <HeaderBoxResume v-if="data.registro_id"
                                   class="matricula_id"
                                   :info="data.registro.pessoa.cpf | cpf"
                                   text="CPF" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   :info="data.registro.data_ocorrido | date"
                                   text="Data do ocorrido" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   :info="data.registro.data_registro | date"
                                   text="Data de registro" />
                  <HeaderBoxResume v-if="data.registro_id"
                                   class="matricula_id"
                                   :info="data.registro.matricula | maskMatricula"
                                   text="Matrícula" />
                </b-row>
              </b-col>
              <b-col cols="3"
                     class="d-flex justify-content-end pr-4">
                <NavegacaoRegistros :prop-registro-id="data.registro_id"
                                    :prop-tipo-registro="data.registro.tipo_registro" />
              </b-col>
            </b-row>
          </div>
        </b-row>
      </h4>
    </header-blue>
    <b-tabs content-class=""
            class="Resumo-border"
            align="left"
            active-nav-item-class="Resumo--tab-active">
      <b-tab @click="tabIndex = 0">
        <template v-slot:title>
          <icon-svg icon="nascimento"
                    class="icon--sm" />
          Resumo
        </template>

        <resumo-nascimento-detalhes v-if="tabIndex == 0"
                                    :data="data"
                                    :prop-gerar-cpf="propGerarCPF"
                                    :prop-pedido-pendente="propPedidoPendente"
                                    :prop-numero-pedido-possue-certidao-eletronica="numeroPedidoPossueCertidaoEletronica"    
                                    @changeCPF="changeCPF"
                                    @updateNascimento="updateNascimento"
                                    @fecharModalAvisoNumeroPedidoPossuiCertidaoEletronica="onFecharModal" />
      </b-tab>

      <b-tab :active="tabIndex == 1"
             :disabled="!gemeos || !gemeos.length"
             @click="tabIndex = 1">
        <template v-slot:title>
          <icon-svg icon="accountGroup"
                    class="icon--sm" />
          Gêmeos
        </template>
        <div>
          <ResumoGemeos v-if="tabIndex == 1"
                        :prop-data="data"
                        :prop-gerados="propGerados" />
        </div>
      </b-tab>

      <b-tab @click="tabIndex = 2">
        <template v-slot:title>
          <icon-svg icon="image"
                    class="icon--sm" />
          Imagens
        </template>

        <resumo-imagens
          v-if="registro_id"
          tipo-registro="N"
          :prop-imagens="data.registro.documentos"
          :registro-id="registro_id"
          @updateData="updateData" />
      </b-tab>

      <b-tab @click="tabIndex = 3">
        <template v-slot:title>
          <icon-svg icon="note"
                    class="icon--sm" />
          Averbações/Anotações
        </template>

        <AverbacaoEProcedimento v-if="data.registro && tabIndex === 3"
                                :prop-tipo-registro="data.registro.tipo_registro"
                                :prop-registro-id="data.registro_id"
                                :prop-registro="data.registro"
                                :prop-data="data"
                                :prop-transporte="data.registro.transporte"
                                @onTabImpressao="tabImpressao"
                                @imprimir="imprimir" />
      </b-tab>

      <b-tab :active="newOs || tabIndex == 4"
             @click="tabIndex = 4">
        <template v-slot:title>
          <icon-svg icon="dolar"
                    class="icon--sm" />
          Ordens de Serviços
        </template>
        <resumo-ordens-servicos
          v-if="registro_id && tabIndex == 4"
          :prop-registro-id="registro_id"
          :prop-tipo="'nascimento'"
          :prop-registro="data.registro"
          :prop-data="data"
          :prop-solicitante="solicitante"
          :prop-novo="compNewOs"
          :prop-gemeos="propGerados"
          :prop-gerar-cpf="gerar_cpf"
          :prop-os="propIdOs"
          :prop-pedido-pendente="pedidoPendente"
          :prop-segunda-via="compOsSegundaVia"
          :prop-pedido-p13="propPedidoP13"
          :prop-numero-pedido-possue-ordem-servico="numeroPedidoPossueOrdemServico"
          @onUpdateOrdemServico="updateOrdemServico"
          @onNewOs="value => newOs = value"
          @imprimir="imprimir" />
      </b-tab>

      <b-tab v-if="data.registro"
             :active="tabIndex == 5"
             :disabled="data.registro.cod_motivo_alt == 30"
             @click="tabIndex = 5">
        <template v-slot:title>
          <icon-svg icon="print"
                    class="icon--sm" />
          Impressão
        </template>

        <Impressao v-if="tabIndex == 5"
                   :data="data"
                   :ordem-servico="ordem_servico"
                   :prop-pedido-pendente="propPedidoPendente"
                   :prop-pedido-provimento="propPedidoP13"
                   :prop-imprimir-os="os"
                   tipo="nascimento" />
        <span v-else />
      </b-tab>
      <b-tab :active="tabIndex == 6"
             @click="tabIndex = 6">
        <template v-slot:title>
          <icon-svg icon="copy"
                    class="icon--sm" />
          2ª via
        </template>
        <SegundaViaNascimento v-if="tabIndex === 6 && data.registro"
                              :prop-nascimento="data"
                              @changeRegistro="changeRegistro"
                              @goOS="goOS" />
      </b-tab>

      <b-tab :active="tabIndex === 7"
             @click="tabIndex = 7">
        <template v-slot:title>
          <icon-svg icon="qrcode"
                    class="icon--sm" />
          Selos
        </template>

        <ResumoSelos v-if="tabIndex === 7"
                     :prop-registro-id="data.registro_id || registro_id"
                     :prop-cpf-registrado="data.registro.pessoa.cpf"
                     :prop-nome-registrado="data.registro.pessoa.nome"
                     :prop-open-window-editar-vinculacao="propOpenWindowEditarVinculacao" />
      </b-tab>
    </b-tabs>
    <hr>
    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @assinarDocumento="assinarDocumento(registro_id_cpf)" />
    </b-modal>
  </div>
</template>

<script>
  /* icones */
  import icon_nascimento from "@/assets/icons/nascimento.svg?sprite"
  import icon_image from "@/assets/icons/file-image.svg?sprite"
  import icon_note from "@/assets/icons/note.svg?sprite"
  import icon_dolar from "@/assets/icons/dolar.svg?sprite"
  import icon_print from "@/assets/icons/print.svg?sprite"

  /* componentes */
  import HeaderBlue from "@/components/SofiaRei/Headers/HeaderBlue"
  import HeaderBoxResume from "@/components/SofiaRei/Busca/HeaderBoxResume"
  import ResumoNascimentoDetalhes from "@/components/SofiaRei/Resumo/Nascimento/ResumoNascimentoDetalhes"
  import ResumoImagens from "@/components/SofiaRei/Resumo/ResumoImagens"
  import ResumoOrdensServicos from "@/components/SofiaRei/Resumo/ResumoOrdensServicos"
  import Impressao from "@/components/SofiaRei/Resumo/Impressao/Impressao"
  import GridCertificados from '@/components/GridCertificados'
  import NavegacaoRegistros from '@/components/SofiaRei/NavegacaoRegistros'
  import ResumoGemeos from "@/components/SofiaRei/Resumo/Nascimento/ResumoGemeos"
  import ResumoSelos from '@/components/SofiaRei/Resumo/Selo/ResumoSelos'
  import SegundaViaNascimento from "@/components/SofiaRei/Nascimento/SegundaVia/SegundaViaNascimento"
  import AverbacaoEProcedimento from '@/components/SofiaRei/Casamento/AverbacaoEProcedimento.vue'

  /* services */
  import NascimentoService from "@/services/Registros/Nascimento"

  /* filters */
  import { maskCPF } from "@/filters/filters"

  /* services */
  import BryService from "@/services/Assinaturas/BryService"
  import CpfGenerateService from "@/services/Registros/Nascimento/CpfGenerateService"

  /* libraries */
  import { mapGetters } from "vuex"
  import Swal from 'sweetalert2'
  import moment from 'moment'

  /* utils */
  import { cumprirPedidos } from '@/utils/cumprirPedidos'
  
  export default {
    name: "ResumoNascimento",
    components: {
      HeaderBlue,
      HeaderBoxResume,
      ResumoNascimentoDetalhes,
      ResumoImagens,
      ResumoOrdensServicos,
      Impressao,
      GridCertificados,
      NavegacaoRegistros,
      ResumoGemeos,
      ResumoSelos,
      SegundaViaNascimento,
      AverbacaoEProcedimento
    },
    props: {
      propPedidoPendente: {type: Object, default: () => {}},
      propNovo: { type: Boolean, default: () => false },
      propGerarCPF: { type: Boolean, default: () => false },
      propNascimento: {type: Object, default: () => ({})},
      propGerados: { type: Array, default: () => ([])},
      propMostrarSelo: { type: Boolean, default: () => false },
      propOpenWindowEditarVinculacao: { type: Object, default: () => null },
      propIdOs: { type: Number, default: null},
      propTabSegundaVia: { type: Boolean, default: false},
      propPedidoP13: {type: Object, default: () => {}}
    },
    data () {
      return {
        icons: {
          icon_nascimento: icon_nascimento,
          icon_image: icon_image,
          icon_note: icon_note,
          icon_dolar: icon_dolar,
          icon_print: icon_print
        },
        data: {
          registro: {
            partes: [],
            pessoa: {
              genitores: [],
              gemeos: [],
            },
            local: {
              endereco: {}
            },
            livro: {}
          }
        },
        solicitante: {},
        ordem_servico: [],
        registro_id: null,
        certificados: [],
        certificadoSelecionado: null,
        newOs: false,
        tabIndex: 0,
        cpfGerado: '',
        os: {},
        gemeos: [],
        registro_id_cpf: null,
        gerar_cpf: false,
        segundaVia: false,
        pedidoPendente: {},
        ordemServicoCompare: [],
        gerenciarExibicaoRecibo: false,
        numeroPedidoPossueOrdemServico: false,
        numeroPedidoPossueCertidaoEletronica: false,
        respostaModalNumeroPedidoPossuiCertidaoEletronica: ''
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        modalImpressaoEstaFechado: 'impressaoReciboOS/getModalImpressaoEstaFechado',
        recusarImpressaoReciboDeServico: 'impressaoReciboOS/getRecusarImpressaoReciboDeServico'
      }),
      compNewOs () {
        return this.newOs
      },
      compOsSegundaVia () {
        return this.segundaVia && (this.ordemServicoCompare.length === this.ordem_servico.length)
      }
    },
    watch: {
      propNovo () {
        if (this.propNovo) {
          this.newOs = true
          this.tabIndex = 4
        }
      },
      cpfGerado () {
        this.data.registro.pessoa.cpf = this.cpfGerado
      },
      propNascimento () {
        if (Object.values(this.propNascimento).length) {
          this.changeRegistro(this.propNascimento)
          return
        }
      },
      async '$route.params.id' () {
        this.init()
      },
      data () {
        if (Object.keys(this.data).length) {
          const { gemeos } = this.data.registro.pessoa

          this.gemeos = gemeos
        }
      },
      modalImpressaoEstaFechado (novoValor) {
        this.gerenciarExibicaoRecibo = novoValor
      },
      gerenciarExibicaoRecibo (novoValor) {
        novoValor && this.tabImpressao()
      },
      recusarImpressaoReciboDeServico () {
        this.tabImpressao()
      }
    },
    async created () {
      this.$watch(
        () => [this.tabIndex, this.numeroPedidoPossueOrdemServico],
        ([novoTab, novoNumero], [velhoTab, velhoNumero]) => {
          if (velhoTab !== 0 && novoTab !== 4 && velhoNumero !== false && novoNumero == true) this.numeroPedidoPossueOrdemServico = false
        },
        { immediate: false, deep: false }
      )

      await this.init()

      if (this.propMostrarSelo) {
        this.tabIndex = 7
      }
    },
    beforeMount () {
      if (this.$route.query && this.$route.query.mostrarSelos) {
        const params = {
          propMostrarSelo: true
        }

        if (this.$route.query.seloVinculador && this.$route.query.dataVinculacao) {
          params.propOpenWindowEditarVinculacao = {
            numSeloVinculador: this.$route.query.seloVinculador,
            dataVinculacao: moment(this.$route.query.dataVinculacao, 'DD-MM-YYYY-HH-mm-ss').format('YYYY-MM-DD HH:mm:ss')
          }
        }

        /**
         * Precisamos fazer um push na mesma rota, para passar as props, e para limpar a query do route, pois é imutável.
         * Se não fizermos isso, ao atualizar a página, sempre vai direcionar lá para tab de selos novamente, e queremos que o usuário navegue livremente.
         */
        this.$router.push({ name: 'resumo_nascimento', params: { id: this.$route.params.id, ...params } })
      }
    },
    methods: {

      tabImpressao () {
        this.tabIndex = 5

      },

      async init () {
        try {
          loader({ text: 'Carregando...', active: true })

          this.data = await NascimentoService.getNascimentoById(this.$route.params.id, this.$store.state.auth.cartorio_id, this.registro_id)
          this.registro_id =  this.data.registro_id
          this.updateOrdemServico(this.data.registro.ordemServico)
          this.setSolicitante()

   

        } catch (error) {
          if (error.response && error.response.status == 404) {
            this.$router.push('/pagina-nao-encontrada')
          }

          console.error(error)
        } finally {
          loader({ text: '', active: false })
        }

        if (this.data.registro && this.data.registro.documentosGED) {
          // mostrar apenas permitidos
          const docsGed = this.data.registro.documentosGED.filter(documento => {
            return ['PDF', 'PDFA'].indexOf(documento.tipo_documento) !== -1
          })
          this.data.registro.documentos =  this.data.registro.documentos.concat(docsGed)
        }

        if (this.propGerarCPF) {
          await this.gerarCpfNascidos()
        }

        if (this.propNovo && !this.propTabSegundaVia) {
          this.newOs = true
          this.tabIndex = 4
        } else if (this.propTabSegundaVia) {
          this.tabIndex = 6
        } else if (this.propIdOs) {
          this.tabIndex = 4
        } else {
          this.tabIndex = 0
        }

        if (this.propPedidoP13) {
          this.tabIndex  = 4
          this.newOs = true
        }

        if (this.propPedidoPendente) {
          this.pedidoPendente = this.propPedidoPendente
          this.tabIndex = 4

          if ((!this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) || (!this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica)) {
            this.newOs = true
          }

          if (this.propPedidoPendente.numPedidoPossueOrdemServico && !this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
            this.numeroPedidoPossueOrdemServico = true
            this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-ordem-servico'))
          }

          if (this.propPedidoPendente.numPedidoPossueOrdemServico && this.propPedidoPendente.numPedidoPossueCertidaoEletronica) {
            this.tabIndex = 0
            this.numeroPedidoPossueCertidaoEletronica = true
            this.$nextTick(() => this.$bvModal.show('aviso-numero-pedido-possui-certidao-eletronica'))
          }
        }
      },
      updateOrdemServico (data) {
        if (data)
          this.ordem_servico = [...data]
        else
          this.ordem_servico = []
      },
      setSolicitante () {
        const [solicitante] = this.data.registro.partes.filter(parte => parte.tipo === "DECLARANTE")
        if (solicitante) {
          this.solicitante = solicitante.pessoa
        }
      },
      async gerarCPF (registroId) {
        loader({ text: 'Validando extensão...', active: true })

        if (!this.data.numero_declaracao_nascido_vivo) {
          return displayMessage('error', 'Erro!', 'Informe o Nº Declaração Nascido Vivo.')
        }

        const validateExt = await this.validateExtension()

        if (!validateExt) return

        loader({ text: 'Obtendo certificados...', active: true })

        this.certificados = await BryService.getCertificates()

        if (!this.certificados.length) {
          NProgress.done()
          loader({ text: '', active: false })

          this.tabIndex = 4

          objSwal.error.title = 'Erro'
          objSwal.error.text = 'Não foi possível selecionar o certificado'
          objSwal.error.html = ''
          return Swal.fire(objSwal.error)
        }

        if (this.certificados.length > 1) {
          loader({ text: '', active: false })
          this.$refs.modalCertificados.show()
        } else {
          this.certificadoSelecionado = this.certificados[0]

          // Anulando certificados obtidos
          this.certificados = null

          return this.assinarDocumento(registroId)
        }
      },
      validateExtension () {
        const installed = BryService.isExtensionInstalled

        loader({ text: '', active: false })

        if (installed) return true

        objSwal.info.title = 'Extensão não instalada'
        objSwal.info.text = 'A extensão para assinatura digital não está instalada no seu navegador. Deseja instalar agora?'
        objSwal.info.confirmButtonText = 'Instalar'
        objSwal.info.showCancelButton = true
        objSwal.info.cancelButtonText = 'Não'

        return Swal.fire(objSwal.info).then(({ value }) => {
          if (value) {
            try {
              BryService.getExtension()
            } catch (e) {
              this.closeLoaderWithError('Erro', e.message)
            }
          }
        })
      },
      async updateData () {
        this.data = await NascimentoService.getNascimentoById(this.$route.params.id, this.$store.state.auth.cartorio_id, this.registro_id)
      },
      async assinarDocumento (registroId) {
        // Fechando modal
        this.$refs.modalCertificados.hide()

        // Anulando certificados obtidos
        this.certificados = []

        loader({ text: 'Assinando documento...', active: true })

        try {
          // Iniciamos a assinatura
          const start = await CpfGenerateService.startSigning(registroId, this.certificadoSelecionado.certificateData)
          const assinaturaInicializada = start.init.assinaturasInicializadas[0]

          // Pegamos o cifrado
          const signBase = await BryService.signBase64Content(
            this.certificadoSelecionado.certId, BryService.prepareContentForSignature(assinaturaInicializada.messageDigest, assinaturaInicializada.nonce))

          // A assinatura funciona como lote, aqui só assinamos 1 documento, entao coloco sempre no array.
          const documents = [{
            original: start.documents[0].document,
            signatureValue: signBase.assinaturas[0].hashes[0],
            file_name: start.documents[0].file_name,
            signedAttributes: start.init.assinaturasInicializadas[0].messageDigest
          }]

          // Finalizamos a assinatura
          const response = await CpfGenerateService.endSigning(registroId, start.init.nonce, this.certificadoSelecionado.certificateData, documents, signBase)

          NProgress.done()
          loader({ text: '', active: false })
          return response.cpfGerado

        } catch (error) {
          console.error(error)
          NProgress.done()
          loader({ text: '', active: false })

          objSwal.error.title = 'Não foi possível realizar a assinatura'

          // Se o erro vier da API da bry
          if (error.description) {
            objSwal.error.text = `${JSON.stringify(error.description)}`
          }
          // Se vier da API do Barramento
          else if (error.response.data.message && error.response.data.message.message) {
            objSwal.error.text = `${JSON.stringify(error.response.data.message.message)}`
          }

          // Se vier da API do Sofia-rei
          else if (error.response.data && Array.isArray(error.response.data)) {
            const message = getErrors(error.response.data[0])

            objSwal.error.text = message.message
          }

          else {
            const message = getErrors(error)

            objSwal.error.text = message.message
          }

          if (objSwal.error.text && objSwal.error.text.match('CPF da pai')) {
            objSwal.error.text = objSwal.error.text.replace('CPF da pai', 'CPF do pai')
          }

          return Swal.fire(objSwal.error)
        }
      },
      changeCPF (cpf) {
        this.data.registro.pessoa.cpf = cpf
      },
      updateNascimento (data) {
        this.data = data
      },
      imprimir (os) {
        this.os = os
      },
      changeRegistro (registro) {
        this.newOs = false
        this.data = registro
      },
      async gerarCpfNascidos () {
        const cpfsGerados = []

        for (const gerado of this.propGerados) {
          if (gerado.gerar_cpf && gerado.registro_id) {
            this.registro_id_cpf = gerado.registro_id
            try {
              const cpf = await this.gerarCPF(gerado.registro_id)

              if (cpf && typeof cpf !== 'object') {
                const obj = {
                  nome: gerado.nome,
                  cpf: cpf
                }

                cpfsGerados.push(obj)

                if (gerado.registrado) {
                  this.changeCPF(cpf)

                  this.cpfGerado = cpf
                }
              }
            } catch (error) {
              console.error(error)
            }
          }
        }

        if (cpfsGerados.length) {
          let html = 'Os seguintes CPFs foram gerado com sucesso:'
          cpfsGerados.forEach(gerado => {
            html += `<br>- ${gerado.nome}:`
            html += `<br>CPF nº <b>${maskCPF(gerado.cpf)}</b>`
          })

          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = html

          return Swal.fire(objSwal.success)
        }

        this.tabIndex = 4
        this.gerar_cpf = true
      },
      getGemeos (gemeos) {
        this.data.registro.pessoa.gemeos = gemeos
      },
      goOS (registro) {
        this.segundaVia = true

        this.changeRegistro(registro)

        this.tabIndex = 4

        this.ordemServicoCompare = [...this.ordem_servico]
      },
      onFecharModal (status, resposta) {
        this.numeroPedidoPossueCertidaoEletronica = status
        this.respostaModalNumeroPedidoPossuiCertidaoEletronica = resposta

        if (resposta === 'Sim') {
          cumprirPedidos(this.propPedidoPendente)
        } else {
          this.tabIndex = 4
          this.numeroPedidoPossueOrdemServico = true
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../scss/_components/resumos';
  .headerBlue{
    height: 100%;
  }

  .registro {
    &_title {
      width: 17% !important;
    }

    &_dados {
      width: 80%;
    }
  }
</style>
